
import {Component, OnInit, ViewChild} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {ReactiveFormsModule} from '@angular/forms';
import {FormGroup, FormControl, Validators} from '@angular/forms';
import {Router, ActivatedRoute} from '@angular/router';
import {LoginService} from '../../service/LoginService';
import {Popup} from 'ng2-opd-popup';
import {PassService} from '../../service/PassService';
import {Login} from '../../model/login-model';
import {HttpErrorResponse} from '@angular/common/http';
import {UserVO} from '../../model/UserVO';
declare var $: any;
import {Md5} from "md5-typescript";
import {TenantconfigVO} from '../../model/TenantconfigVO';
@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})

export class LoginComponent implements OnInit {


    log: Login
    signinform: FormGroup;
    error: any; focus: boolean;
    email: any;
    multipleUsers: any;
    userVO: UserVO;
    password: string;
    tenantconfigVO:TenantconfigVO = new TenantconfigVO();

    constructor(private popup1: Popup, public passer: PassService, private route: ActivatedRoute, private router: Router, private login: LoginService
    ) {
        this.log = new Login()
        this.signinform = new FormGroup({
            "username": new FormControl(null, [Validators.required, Validators.email]),
            "password": new FormControl(null, Validators.required)

        });

    }


    ngOnInit() {
        this.passer.header = false;
    }

    onClick() {
        if (this.log.username && this.password) {
            console.log("clicked");
            this.getMultipleusers();
        } else {
            alert("Enter Login Credentials")
        }

        //        this.login.loginvalidate(this.log).subscribe(
        //            (data) => {
        //                data;
        //                let users: any = data;
        //                if (users.companyVO.portCodes != null || users.companyVO.portCodes != undefined) {
        //                    this.passer.ports = users.companyVO.portCodes
        //                    //                    let x = stringToSplit.split(",");
        //                    //                    this.passer.ports = x;
        //                }
        //                this.passer.home = users;
        //                console.log("userVOsaved", this.passer)
        //                if (data) {
        //                    this.router.navigate(['home'], {skipLocationChange: true});
        //                }
        //            },
        //            (err: HttpErrorResponse) => {
        //                if (err.error instanceof Error) {
        //
        //                    console.log("Client-side error occured." + err.message);
        //                    window.alert("Login failed...." + err.message);
        //                } else {
        //
        //                    this.error = err.error.message;
        //
        //                }
        //            });

    }
    popup_close() {
        this.popup1.hide();
    }
    removeAlert() {
        this.error = undefined;
    }

    fpwd() {
        this.email = null;
        $("#forgot").modal({backdrop: 'static', keyboard: false}, 'show');
    }

    closefpwd() {
        $("#forgot").modal('hide');
    }
    sendfpwd() {
        if (this.email) {
            var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var isValid = re.test(this.email);
            console.log(isValid);
            if (isValid == true) {
                $("#forgot").modal('hide');
                this.login.generateRandomPassword(this.email).subscribe((res: boolean) => {
                    res;
                    if (res == true) {
                        alert("New Password Send To Your Mail!!!");
                    }
                }, (err: HttpErrorResponse) => {
                    alert(err.error.message)
                })
            } else {
                alert("Please Enter Valid Mail!!!");
            }
        } else {
            alert("Please Enter Mail!!!");
        }

    }
    getMultipleusers() {
        let decryptedPswd = this.password;
        this.password = Md5.init(decryptedPswd)
        this.log.password = Md5.init(decryptedPswd);
        this.userVO = new UserVO(0, this.log.username, this.log.password, "", "", 0, "", 0);
        this.login.getMultipleusers(this.userVO).subscribe((res: any) => {
            res;
            if (res.length > 1) {
                this.multipleUsers = res;
                console.log("this.multipleUsers", this.multipleUsers)
                $("#multipleUser").modal({backdrop: 'static', keyboard: false}, 'show');
            } else {
                this.login.loginvalidate(this.log).subscribe(
                    (data) => {
                        data;
                        let users: any = data;
                        if (users.companyVO.portCodes != null || users.companyVO.portCodes != undefined) {
                            this.passer.ports = users.companyVO.portCodes
                            //                    let x = stringToSplit.split(",");
                            //                    this.passer.ports = x;
                        }
                        this.passer.home = users;
                        this.getTenantConfig();
                        console.log("userVOsaved", this.passer)
                        if (data) {
                            this.router.navigate(['home'], {skipLocationChange: true});
                        }
                    },
                    (err: HttpErrorResponse) => {
                        if (err.error instanceof Error) {

                            console.log("Client-side error occured." + err.message);
                            window.alert("Login failed...." + err.message);
                        } else {

                            this.error = err.error.message;

                        }
                    });
            }
        }, (err: HttpErrorResponse) => {
        console.log("err",err);
           console.log("err.error",err.error);
              console.log("err.error.message",err.error.message);
            alert(err.error.message)
        })
    }
    userSelection(e, item) {
        console.log(e, item);
        this.log.exportCompanyid = item.exportCompanyid;

    }
    closemultipleuser() {
        $("#multipleUser").modal('hide');
    }
    multipleuserLogin() {
        this.login.loginvalidate(this.log).subscribe(
            (data) => {
                data;
                let users: any = data;
                if (users.companyVO.portCodes != null || users.companyVO.portCodes != undefined) {
                    this.passer.ports = users.companyVO.portCodes
                    //                    let x = stringToSplit.split(",");
                    //                    this.passer.ports = x;
                }
                this.passer.home = users;
                console.log("userVOsaved", this.passer)
                 this.getTenantConfig();
                if (data) {
                    this.router.navigate(['home'], {skipLocationChange: true});
                }
                $("#multipleUser").modal('hide');
            },
            (err: HttpErrorResponse) => {
                if (err.error instanceof Error) {

                    console.log("Client-side error occured." + err.message);
                    window.alert("Login failed...." + err.message);
                } else {

                    this.error = err.error.message;

                }
            });
    }
    
    getTenantConfig(){
        this.tenantconfigVO.key = "FETCH_SIZE";
         this.login.getTenantConfig(this.tenantconfigVO).subscribe((res: any) => {
            res;
            if(res){
                console.log("res",res)
               this.passer.fetchSize = res.value;
            }
         });
    }
}


// WEBPACK FOOTER //
// D:/ESealStore_AJS/src/app/components/login/login.component.ts